import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable()
export class FriendService {
    constructor(private http: HttpService) {
    }

    SetRelation(params, callback) {
        // this.rest.postapi({url: 'mypage/set-relation', params: params}, function(obj){
        this.http.post({url: 'mypage/set-relation', params}).then((res) => {
            if (typeof callback !== 'undefined') {
                callback(res);
            }
        });

        // after callback sample
        // if(obj.result === true){
        //        this.friend_nick === "";
        //        this.friendAdded.emit();
        //        this.toasterService.showToaster('info', "친구로 추가되었습니다.");
        //    }else{
        //        this.toasterService.showToaster('error', obj.message);
        //    }
    }

    // Talk(params, callback){
    //    if(typeof (callback) !== 'undefined')
    //        callback(obj.result);
    // }

}
